import { ConfigContext } from '../context/ConfigContext';
import { useContext } from 'react';
import { brandForDomain } from '../utils/platform/brand';

export const useConfig = () => {
  const { config } = useContext(ConfigContext);

  const brand = brandForDomain();

  const thisConfig = config.find((a) => a?.brand === brand);

  const configForBrand = (brandName: string) => config.find((a) => a?.brand === brandName);

  return {
    configs: config,
    configForBrand,
    configForCurrentBrand: thisConfig,
  };
};
